import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src2181110254/src/nuxt/layouts/default.vue").then(m => m.default || m))
}